import { dataLayerPush } from '@nrdy-marketing-engine/gtm/src/data-layer-actions';
import trackFreemiumFormInteractions from './track-freemium-form-interactions';

type HTMLInputish = Partial<Pick<HTMLInputElement, 'checked' | 'name' | 'type' | 'value'>>;
type LoggableEvent = { target: EventTarget | HTMLInputish; type?: string };

/** Returns true if the given object acts like an HTMLInputElement (has a name and value) */
const isInputish = (target): target is HTMLInputish =>
  'name' in target && 'value' in target && target.name;

function fieldData(e: LoggableEvent) {
  const target = e.target;
  if (isInputish(target)) {
    let value = ['checkbox', 'radio'].includes(target.type) ? String(target.checked) : target.value;
    if (target.type === 'password' || target.name === 'password') value = '####';
    return {
      fieldName: target.name.toLowerCase(),
      value: value,
    };
  } else {
    return {
      fieldName: (target as HTMLElement).innerText,
      value: e.type,
    };
  }
}

export function logSubjectAddition(subject: string, clientUuid: string) {
  dataLayerPush('freemium_forms', { event: 'form_submit' });
  trackFreemiumFormInteractions(
    'freemium_forms',
    'submit_success',
    'form_submit',
    `success: ${subject} added to preferences`,
    { clientUuid, subject }
  );
}

export function logSubjectAdditionFailure(message: string, clientUuid: string) {
  dataLayerPush('freemium_forms', { event: 'form_submit' });
  trackFreemiumFormInteractions(
    'freemium_forms',
    'submit_failure',
    'form_submit',
    `failure: failed to add subject to preferences`,
    {
      clientUuid,
      message,
    }
  );
}

export function logFieldChange(e: LoggableEvent) {
  const { fieldName, value } = fieldData(e);
  dataLayerPush('freemium_forms', {
    event: 'field_change',
    fieldName,
    value,
  });
  trackFreemiumFormInteractions('freemium_forms', fieldName, 'field_change', value);
}

export function logSignIn(target?: string) {
  dataLayerPush('freemium_forms', { event: 'form_submit', target });
  trackFreemiumFormInteractions(
    'freemium_forms',
    'submit_success',
    'form_submit',
    'success: sign in'
  );
}

export function logFormSubmitSuccess(target: string) {
  dataLayerPush('freemium_forms', { event: 'form_submit', target });
  trackFreemiumFormInteractions(
    'freemium_forms',
    'submit_success',
    'form_submit',
    `success: ${target}`
  );
}

export function logFormSubmitFailure(target: string, message: string) {
  dataLayerPush('freemium_forms', { event: 'form_submit' });
  trackFreemiumFormInteractions('freemium_forms', 'submit_failure', 'form_submit', message, {
    message,
    target,
  });
}
